module.exports = __webpack_public_path__ + "static/img/enterprise-banner-img.a67a9b73.png";